export function isFornitoriMode(): boolean {
  return process.env.REACT_APP_FORNITORE_CLIENT === "1";
}

export function isItaltexMode(): boolean {
  return process.env.REACT_APP_ITALTEX_CLIENT === "1";
}
